import { motion } from 'motion/react';

import { usePrefersReducedMotion } from '@/lib/motion';
import { cn } from '@/lib/utils';

interface VoiceWaveformProps {
  active: boolean;
  className?: string;
}

const BAR_HEIGHTS = ['8px', '24px', '12px', '20px', '8px'];
const BAR_DELAYS = [0, 0.1, 0.2, 0.1, 0.15];
const STATIC_HEIGHT = '12px';

export function VoiceWaveform({ active, className }: VoiceWaveformProps) {
  const reducedMotion = usePrefersReducedMotion();

  if (!active) return null;

  return (
    <div className={cn('flex items-center justify-center gap-1', className)}>
      {BAR_HEIGHTS.map((height, index) => (
        <motion.span
          key={index}
          className="w-1 rounded-full bg-lime-500"
          animate={{ height: reducedMotion ? STATIC_HEIGHT : [height, '4px', height] }}
          transition={
            reducedMotion
              ? undefined
              : {
                  duration: 0.8,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: BAR_DELAYS[index],
                }
          }
          style={{ height: reducedMotion ? STATIC_HEIGHT : height }}
        />
      ))}
    </div>
  );
}
